import { FormItemsGroup, Input, Space, Spacing, Text } from '@billy/design-system'
import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { useFormContext } from '../../../../hooks/useForm'
import type { CompanyContactFormSchema } from '../../utils/getCompanyContactFormSchema'

interface CompanyContactProps {
  emailLabel?: string
  firstNameLabel?: string
  lastNameLabel?: string
  onEmailChange?: () => void
  onFirstNameChange?: () => void
  onLastNameChange?: () => void
  onPhoneChange?: () => void
  phoneLabel?: string
  withHeading?: boolean
}

export const CompanyContact = ({
  emailLabel,
  firstNameLabel,
  lastNameLabel,
  onEmailChange,
  onFirstNameChange,
  onLastNameChange,
  onPhoneChange,
  phoneLabel,
  withHeading = true,
}: CompanyContactProps): ReactElement => {
  const { t } = useTranslation()
  const { FormItem } = useFormContext<CompanyContactFormSchema>()

  return (
    <>
      {withHeading && (
        <>
          <Space size="s24" />
          <Text variant="h4">{t('external_invoices.company_information_modal.contact')}</Text>
          <Space size="s16" />
        </>
      )}
      <FormItemsGroup itemsInRow={2} rowSpacing={Spacing.S16}>
        <FormItem
          label={firstNameLabel ?? t('external_invoices.company_information_modal.first_name')}
          name="contactFirstName"
          render={({ field: { onChange, ...rest } }) => (
            <Input
              {...rest}
              onChange={(event) => {
                onChange(event)
                onFirstNameChange?.()
              }}
            />
          )}
        />
        <FormItem
          label={lastNameLabel ?? t('external_invoices.company_information_modal.last_name')}
          name="contactLastName"
          render={({ field: { onChange, ...rest } }) => (
            <Input
              {...rest}
              onChange={(event) => {
                onChange(event)
                onLastNameChange?.()
              }}
            />
          )}
        />
      </FormItemsGroup>
      <Space size="s16" />
      <FormItemsGroup itemsInRow={2} rowSpacing={Spacing.S16}>
        <FormItem
          label={emailLabel ?? t('external_invoices.company_information_modal.email')}
          name="contactEmail"
          render={({ field: { onChange, ...rest } }) => (
            <Input
              {...rest}
              onChange={(event) => {
                onChange(event)
                onEmailChange?.()
              }}
            />
          )}
        />
        <FormItem
          label={phoneLabel ?? t('phone_number')}
          name="contactPhone"
          render={({ field: { onChange, ...rest } }) => (
            <Input
              {...rest}
              onChange={(event) => {
                onChange(event)
                onPhoneChange?.()
              }}
            />
          )}
        />
      </FormItemsGroup>
    </>
  )
}
